import niaPic from "@/public/images/artists/nia.png";
import { Artist } from "@/types/types";

export const nia = {
  id: "5",
  name: "Nia",
  image: niaPic,
  description: `While rooted in Hip-Hop, Nia's versatility shines across R&B and Pop genres. She seamlessly transitions between rapid-fire verses and melodic hooks, showcasing an impressive capacity to infuse her lyrics with personality and emotion.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fnia-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Hip Hop", "RnB", "Pop"],
      secondary: ["Rapper", "Singer", "Confident"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 55,
        high: 73,
      },
    },
  },
} as const satisfies Artist;
